import { useGrowthbookExperiment } from './use-growthbook-experiment';

const EXPERIMENT_NAME =
  'sign_core_2026_01_19_restrict_cancel_now_button_to_california_users';

/**
 * Custom hook for the restrict cancel now button experiment.
 * Handles feature flag evaluation and automatic exposure tracking with deduplication.
 *
 * @param isCaliforniaUser - Whether the current user is located in California
 * @returns Object containing experiment state and configuration
 */
export function useRestrictCancelNowExperiment(isCaliforniaUser: boolean) {
  const { isEnabled, experiment } = useGrowthbookExperiment(EXPERIMENT_NAME, {
    shouldLogExposure: !isCaliforniaUser,
  });

  const restrictCancelNow = isEnabled && !isCaliforniaUser;

  return {
    restrictCancelNow,
    isEnabled,
    experiment,
  };
}
